<nav>
  <ul>
    <li>
      <a>
        <i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20px"
            height="13px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(135, 155, 175)"
              d="M20.000,6.500 C20.000,3.467 17.532,1.000 14.500,1.000 C11.467,1.000 9.000,3.467 9.000,6.500 C9.000,8.430 7.428,10.000 5.499,10.000 C3.570,10.000 1.999,8.430 1.999,6.500 C1.999,5.148 2.784,3.919 3.999,3.342 L3.999,5.000 L6.000,5.000 L6.000,2.000 L6.000,-0.000 L3.999,-0.000 L1.000,-0.000 L1.000,2.000 L2.341,2.000 C0.894,3.018 -0.001,4.690 -0.001,6.500 C-0.001,9.533 2.467,12.000 5.499,12.000 C8.532,12.000 10.999,9.533 10.999,6.500 C10.999,4.570 12.570,3.000 14.500,3.000 C16.429,3.000 17.999,4.570 17.999,6.500 C17.999,7.858 17.199,9.089 15.999,9.661 L15.999,8.000 L13.999,8.000 L13.999,11.000 L13.999,13.000 L15.999,13.000 L18.999,13.000 L18.999,11.000 L17.656,11.000 C19.089,9.987 20.000,8.315 20.000,6.500 Z"
            />
          </svg>
        </i>
        <span>Video</span>
      </a>
    </li>
    <li>
      <a routerLink="/autopilot/graphics" routerLinkActive="active">
        <i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20px"
            height="13px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(135, 155, 175)"
              d="M20.000,6.500 C20.000,3.467 17.532,1.000 14.500,1.000 C11.467,1.000 9.000,3.467 9.000,6.500 C9.000,8.430 7.428,10.000 5.499,10.000 C3.570,10.000 1.999,8.430 1.999,6.500 C1.999,5.148 2.784,3.919 3.999,3.342 L3.999,5.000 L6.000,5.000 L6.000,2.000 L6.000,-0.000 L3.999,-0.000 L1.000,-0.000 L1.000,2.000 L2.341,2.000 C0.894,3.018 -0.001,4.690 -0.001,6.500 C-0.001,9.533 2.467,12.000 5.499,12.000 C8.532,12.000 10.999,9.533 10.999,6.500 C10.999,4.570 12.570,3.000 14.500,3.000 C16.429,3.000 17.999,4.570 17.999,6.500 C17.999,7.858 17.199,9.089 15.999,9.661 L15.999,8.000 L13.999,8.000 L13.999,11.000 L13.999,13.000 L15.999,13.000 L18.999,13.000 L18.999,11.000 L17.656,11.000 C19.089,9.987 20.000,8.315 20.000,6.500 Z"
            />
          </svg>
        </i>
        <span>Graphics</span>
      </a>
    </li>
  </ul>
</nav>
